import EChartOption = echarts.EChartOption;

export const commonChartConfig = {
  bg: '#ffffff',
  textColor: '#484848',
  axisLineColor: '#bbbbbb',
  splitLineColor: '#ebeef2',
  itemHoverShadowColor: 'rgba(0, 0, 0, 0.5)',
  areaOpacity: '0.7',
};

export const commonChartTooltip: EChartOption.Tooltip = {
  backgroundColor: '#ffffff',
  textStyle: {
    color: 'rgba(0, 0, 0, 0.65)'
  },
  extraCssText: 'box-shadow: 0 0 5px rgba(0,0,0,0.3)',
};

export const customImpactChartTooltip: EChartOption.Tooltip = {
  backgroundColor: '#ffffff',
  textStyle: {
    color: 'rgba(0, 0, 0, 0.65)'
  },
  extraCssText: 'box-shadow: 0 0 5px rgba(0,0,0,0.3); margin-top: 122px;',
}
